"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CataloguesSkeleton = void 0;
var _hooks = require("../../../hooks");
var _Skeleton = require("../../Skeleton");
var _jsxRuntime = require("react/jsx-runtime");
const CataloguesSkeleton = () => {
  const isMobile = (0, _hooks.useIsMobile)();
  return isMobile ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.SkeletonCatalogueMobile, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.SkeletonCatalogueDesktop, {});
};
exports.CataloguesSkeleton = CataloguesSkeleton;